export var breakPoints = {
  xs: 480,
  sm: 768,
  md: 992,
  lg: 1200
};
export var defaultSizes = {
  phone: breakPoints.sm - 1,
  tablet: breakPoints.md - 1,
  desktop: breakPoints.lg
};
//# sourceMappingURL=defaults.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-responsive-redux/es/defaults.js
// module id = 243
// module chunks = 0